import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles((theme) => ({
  select: {
    color: "inherit",
    marginRight: theme.spacing(1),
    "& .MuiSelect-icon": { color: "inherit" },
    "& .MuiInput-underline:before": {
      borderBottomColor: "rgba(255,255,255,0.4)",
    },
    "& .MuiInput-underline:hover:before": {
      borderBottomColor: "rgba(255,255,255,0.7)",
    },
    fontSize: "0.875rem",
  },
  chip: {
    color: "inherit",
    borderColor: "rgba(255,255,255,0.5)",
    marginRight: theme.spacing(1),
  },
}));

export default function ClientSelector({
  userContext,
  clients,
  selectedClientId,
  onClientChange,
}) {
  const classes = useStyles();

  if (!userContext) return null;

  if (!userContext.isAdmin) {
    return (
      <Chip
        label={userContext.clientName || userContext.clientId}
        variant="outlined"
        size="small"
        className={classes.chip}
      />
    );
  }

  return (
    <Select
      value={selectedClientId || "all"}
      onChange={(e) =>
        onClientChange(e.target.value === "all" ? null : e.target.value)
      }
      className={classes.select}
      disableUnderline
    >
      <MenuItem value="all">StatWars Admin</MenuItem>
      {(clients || []).map((c) => (
        <MenuItem key={c.id} value={c.id}>
          {c.clientName || c.id}
        </MenuItem>
      ))}
    </Select>
  );
}
